import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EmailTagsComponent } from '../email-tags/email-tags.component';
import { MeetingService, AmplitudeService } from '@core/services';

@Component({
    standalone: true,
    selector: 'app-email-modal',
    imports: [CommonModule, FormsModule, EmailTagsComponent],
    templateUrl: './email-modal.component.html'
})
export class EmailModalComponent {

    @Input() meetingBotId: string = '';
    @Input() opportunityId: string = '';
    @Input() emails: string[] = [];

    show = false;
    isValid = false;

    constructor(
        private readonly _meetingService: MeetingService,
        private readonly _amplitudeService: AmplitudeService
    ) { }

    open(): void {
        this.show = true;
    }

    close(): void {
        this.show = false;
    }

    cancel(): void {
        this.close();
    }

    emailList(data: { emails: string[]; invalid: boolean }): void {
        this.emails = data.emails;
        this.isValid = !data.invalid;
    }

    sendEmail(): void {
        this._amplitudeService.trackEvent('opportunity_detail_send_email', {
            opportunity_id: this.opportunityId
        });

        this._meetingService.sendEmail(this.meetingBotId, this.emails).subscribe({
            next: () => {
                this.close();
            }
        })
    }
}
